import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="notes-video"
// Jumps the page's video to the moment a note was written.
export default class extends Controller {
  set_video_time(event) {
    event.preventDefault();

    // The notes sit in a side panel, so the player is elsewhere on the page.
    const iframe = document.querySelector('iframe');
    if (!iframe) return;

    new Vimeo.Player(iframe).setCurrentTime(event.currentTarget.dataset.videoTime);
  }
}
